import { Text } from '@chakra-ui/react';
import cn from 'classnames';
import React from 'react';

import styles from '../new-more-filters.module.scss';

export interface FilterOption {
  id: number;
  value: string;
  isSelected: boolean;
  isDisabled: boolean;
}

interface FilterBlockProps<T extends FilterOptionBase> {
  filter: T;
  onClick: (filter: T) => void;
  className?: string;
}

const FilterBlock = <T extends FilterOptionBase>({
  filter,
  onClick,
  className,
}: FilterBlockProps<T>) => {
  return (
    <div
      className={cn(styles.filterBlock, className, {
        [styles.selected as string]: filter.isSelected,
        [styles.disabled as string]: filter.isDisabled,
      })}
      onClick={() => !filter.isDisabled && onClick(filter)}
    >
      <Text className={styles.bodyTypeText}>
        {filter.name ? filter.name : filter.value}
        <Text as="span" className={styles.filterCount}>
          {filter?.count ? `(${filter.count})` : null}
        </Text>
      </Text>
    </div>
  );
};

interface FilterLabelProps {
  label: string;
}

const FilterLabel: React.FC<FilterLabelProps> = ({ label }) => {
  return (
    <div className={styles.filterLabel}>
      <Text className={styles.labelText}>{label}</Text>
    </div>
  );
};

interface FilterBlockGroupProps<T> {
  label: string;
  filters: T[];
  onSelect: (filter: T) => void;
}

interface FilterOptionBase {
  id: number;
  value: string;
  name?: string;
  isSelected: boolean;
  isDisabled: boolean;
  count?: number;
}
export const FilterBlockGroup = <T extends FilterOptionBase>({
  label,
  filters,
  onSelect,
}: FilterBlockGroupProps<T>) => {
  return (
    <div className={styles.filterBlocks}>
      <FilterLabel label={label} />
      <div className={styles.filterOptions}>
        {filters.map((filter) => (
          <FilterBlock key={filter.id} filter={filter} onClick={onSelect} />
        ))}
      </div>
    </div>
  );
};
